/*
 * @Author: Teemo Ding
 * @Date: 2021-09-06 10:13:45
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-09-15 16:27:40
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelDiscounts/SubscriptionBuy/List/slice/index.ts
 */
import { createSlice } from '@reduxjs/toolkit';
import { unique } from '@/src/tools/helper';
import { tabsConfig } from '../config';

const defaultState = {
  tabsActive: tabsConfig({ getI18n: null })[0].key,
  searchList: [],
  searchText: 0,
  filter: {},
  tableSettings: [],
  allDataTotal: 0,
};
//TODO:Filter单选和多选的问题
const SubscriptionBuyListSlice = createSlice({
  name: 'salesChannelDiscountsSubscriptionBuy',
  initialState: defaultState,
  reducers: {
    searchList: (state, action) => {
      state.searchList.push(action.payload);
      state.searchList = unique(state.searchList); //去重
    },
    deleteSearch: (state, action) => {
      state.searchList.splice(action.payload, 1);
    },
    onFilter: (state, action) => {
      state.filter = action.payload;
    },
    eachOnFilter: (state, action) => {
      state.filter[action.payload.key] = action.payload.data;
    },
    filterClose: (state, action) => {
      state.filter[action.payload.key].splice(action.payload.index, 1);
    },

    activeChange: (state, action) => {
      state.tabsActive = action.payload;
    },
    setTableSetting: (state, action) => {
      state.tableSettings = action.payload;
    },
    removeFilter: (state) => {
      state.searchList = [];
      state.filter = {};
    },
    setAllDataTotal: (state, action) => {
      state.allDataTotal = action.payload;
    },
  },
});

export const {
  searchList,
  deleteSearch,
  onFilter,
  eachOnFilter,
  activeChange,
  setAllDataTotal,
  filterClose,
  removeFilter,
  setTableSetting,
} = SubscriptionBuyListSlice.actions;

export default SubscriptionBuyListSlice.reducer;
